import type { MainMenuExternalLinkKey } from 'constants/mainMenuExternalLinks';

export type MainMenuSidebarMenuItem = {
  labelKey: string;
  linkKey: MainMenuExternalLinkKey;
  emoji: string;
};

export const HELP_SUPPORT_MENU_ITEMS: MainMenuSidebarMenuItem[] = [
  {
    labelKey: 'helpSupportMenu.whatsNew',
    linkKey: 'helpWhatsNew',
    emoji: '🔔',
  },
  {
    labelKey: 'helpSupportMenu.guides',
    linkKey: 'helpGuides',
    emoji: '📖',
  },
  {
    labelKey: 'helpSupportMenu.adminManual',
    linkKey: 'helpAdminManual',
    emoji: '📘',
  },
  {
    labelKey: 'helpSupportMenu.contactUs',
    linkKey: 'helpContactUs',
    emoji: '✉️',
  },
  {
    labelKey: 'helpSupportMenu.sendFeedback',
    linkKey: 'helpSendFeedback',
    emoji: '💬',
  },
];

export const ABOUT_GUMB_MENU_ITEMS: MainMenuSidebarMenuItem[] = [
  {
    labelKey: 'aboutGumbMenu.pricing',
    linkKey: 'aboutPricing',
    emoji: '💳',
  },
  {
    labelKey: 'aboutGumbMenu.roadmap',
    linkKey: 'aboutRoadmap',
    emoji: '🗺️',
  },
  {
    labelKey: 'aboutGumbMenu.aboutUs',
    linkKey: 'aboutAboutUs',
    emoji: '👥',
  },
  {
    labelKey: 'aboutGumbMenu.website',
    linkKey: 'aboutWebsite',
    emoji: '🌐',
  },
];
